import React from 'react';
import * as S from "../Publications/Structure/PublicationStructure.style";
import { env } from 'config';

const PublicationsComponent = ({ publications, pubText = "Baixar em PDF" }) => {
  const categories = publications.reduce((acc, pub) => {
    let category = pub.category;
    if (!acc.includes(category)) acc.push(category);
    return acc;
  }, []);

  return (
    <S.Grid>
      {categories.map(cat => (
        <S.GridContainer key={cat}>
          <S.GridItem>
            <S.TitleTopic variant="headline-02" color="Grey">
              {cat}
            </S.TitleTopic>
          </S.GridItem>
          {publications.filter(pub => pub.category === cat).map(pub => (
            <React.Fragment key={pub.title}>
              <S.GridItem>
                <S.TitleItem variant="headline-03" color="primary">
                  {pub.title}
                </S.TitleItem>
                <S.Description variant="body02-md" color="primary-dark">
                  {pub.description}
                </S.Description>
                <div style={{ display: "flex", }}>
                  <S.DownloadIcon />
                  <S.LinkDownload
                    target="_blank"
                    href={`${env.HOST_STATIC_CDN}${pub.link}`}
                    rel="noreferrer"
                  >
                    {pub.pubText ?? pub.linkOtherLanguage ? `${pubText} (português)` : pubText}
                  </S.LinkDownload>
                  {pub.linkOtherLanguage && (
                    <>
                      <S.DownloadIcon style={{ marginLeft: "30px" }} />
                      <S.LinkDownload
                        style={{ margin: "0 0 44px 0" }}
                        target="_blank"
                        href={`${env.HOST_STATIC_CDN}${pub.linkOtherLanguage}`}
                        rel="noreferrer"
                      >
                        {pub.pubText ?? `${pubText} (Inglês)`}
                      </S.LinkDownload>
                    </>
                  )}
                </div>
              </S.GridItem>
              <S.GridItem />
            </React.Fragment>
          ))}
        </S.GridContainer>
      ))}
    </S.Grid>
  );
};

export default PublicationsComponent;
